import React from 'react';
import { useTranslation } from 'react-i18next';

const Resources = () => {
  const { t } = useTranslation();
  return (
    <div className="resources">
      <h1>{t('resources.title', 'Ressources & Outils')}</h1>
      <ul>
        <li><a href="#">Guide de bonnes pratiques (PDF)</a></li>
        <li><a href="#">Outil d’évaluation de cycle de vie (Excel)</a></li>
        <li><a href="#">Documentation API (HTML)</a></li>
      </ul>
    </div>
  );
};

export default Resources;